export const formatCurrency = (value: number | string): string => {

    const amount = Number(value);

    if (isNaN(amount)) return "0";

    return amount.toLocaleString('en-US', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    })
};

export const formatNumber = ( value: number | null | undefined, locale: string = "en-US" ): string => {
    return (value ?? 0).toLocaleString(locale);
};